import qs from 'qs';
import { RootState } from '../../../slices/rootReducer';

export const getQueryParameterFromPath = (state: RootState, field: string): string => {
  const queryParamsRaw = state.router.location.search || '';
  const queryParams = qs.parse(queryParamsRaw, { ignoreQueryPrefix: true });
  if (queryParams[field]) {
    return queryParams[field] as string;
  }
  return '';
};
